import { Avatar, Grid, Stack, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../../helpers';
import { LoadingWidget, ModalComponent } from '../../../../widgets';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { allEntNivelesAcademicosAction } from '../../../entidad/ent_niveles_academicos/EntNivelesAcademicosAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { allAsistenciasAction } from '../AsistenciasAction';
import { PARAMS_ASISTENCIAS_DIARIAS } from '../AsistenciasReducer';
import CuadroAsistenciasComponent from '../CuadroAsistencias';

let intervalSearch = null;

const ListadoAsistencias = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );

  const [openModalCuadro, setOpenModalCuadro] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        entNivelesAcademicosStore.all &&
        entNivelesAcademicosStore.all.length === 0
      ) {
        await allEntNivelesAcademicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      const payload = {
        ...asistenciasStore.params,
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        desde: dateformat(null, {}),
        hasta: dateformat(null, {}),
      };
      dispatch({ type: PARAMS_ASISTENCIAS_DIARIAS, payload });
      if (asistenciasStore.all && asistenciasStore.all.length === 0) {
        await allAsistenciasAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    asistenciasStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        fecha: dateformat(el.fechaHora, { format: 'DD-MM-YYYY HH:mm A' }),
        docente: `${el.horario.docente.usuario.perfil.pnombre} ${el.horario.docente.usuario.perfil.papellido}`,
        horario: {
          horario: `${el.horario.horaInicio} ${el.horario.horaFinal}`,
          materia: el.horario.materia?.nombre ?? '--',
        },
        nombre: {
          avatar: el.estudiante.usuario.perfil.avatar,
          nombre: `${el.estudiante.usuario.perfil.dni} ${
            el.estudiante.usuario.perfil.pnombre
          } ${el.estudiante.usuario.perfil.snombre ?? ''} ${
            el.estudiante.usuario.perfil.papellido
          } ${el.estudiante.usuario.perfil.sapellido ?? ''}`,
          nivelAcademico: el.horario.seccion.nivelAcademico.nombre,
          seccion: el.horario.seccion.nombre,
          turno: el.horario.seccion.turno,
        },
      });
    });
    setRows(rowsData);
  }, [asistenciasStore.all]);

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center">
              <Avatar
                alt={value}
                sx={{ width: 30, height: 30, mr: 1 }}
                src={getFilesArchivos(value.avatar)}
              />
              <Stack direction="column">
                <NameComponent>{value.nombre}</NameComponent>
                <Stack direction="row" spacing={1}>
                  <Typography variant="caption">
                    <strong>Nivel acadêmico: </strong>
                    {value.nivelAcademico}
                  </Typography>
                  <Typography variant="caption">
                    <strong>Sección: </strong>
                    {value.seccion}
                  </Typography>
                  {/* <Typography variant="caption">
                    <strong>Turno: </strong>
                    {value.turno}
                  </Typography> */}
                </Stack>
              </Stack>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.fecha.name,
      label: CONST.fecha.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.docente.name,
      label: CONST.docente.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.horario.name,
      label: CONST.horario.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack>
              <Typography variant="subTitle1" sx={{ fontWeight: 'bold' }}>
                {value.horario}
              </Typography>
              <Typography variant="caption">{value.materia}</Typography>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <Stack direction="row"></Stack>;
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: asistenciasStore.params.limit,
    count: asistenciasStore.pagination.totalItems,
    page: asistenciasStore.pagination.currentPage - 1,
    rowsPerPageOptions: [50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(async () => {
          const payload = {
            ...asistenciasStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_ASISTENCIAS_DIARIAS, payload });
          await allAsistenciasAction(dispatch, payload);
        }, 800);
      }
    },
    onSearchClose: async () => {
      const payload = {
        ...asistenciasStore.params,
        q: null,
      };
      dispatch({ type: PARAMS_ASISTENCIAS_DIARIAS, payload });
      await allAsistenciasAction(dispatch, payload);
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...asistenciasStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_ASISTENCIAS_DIARIAS,
        payload,
      });
      await allAsistenciasAction(dispatch, payload);
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...asistenciasStore.params,
        limit: numberOfRows,
      };
      dispatch({
        type: PARAMS_ASISTENCIAS_DIARIAS,
        payload,
      });
      await allAsistenciasAction(dispatch, payload);
    },
  };

  return (
    <Grid container>
      <LoadingWidget isLoading={asistenciasStore.loadingAll} />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {asistenciasStore.activo && (
        <ModalComponent
          id="modalCuadroAsistencias"
          title={`Cuadro de asistencias`}
          open={openModalCuadro}
          maxWidth="lg"
          onClose={() => setOpenModalCuadro(!openModalCuadro)}
        >
          <CuadroAsistenciasComponent />
        </ModalComponent>
      )}
    </Grid>
  );
};

export default ListadoAsistencias;
